<template>
    <div class="common-layout">
        <div style="width:3%;">
            <el-popover :visible="show" placement="right-start" :width="230" style="height:300px">
                <template #reference>
                    <el-menu default-active="1" class="el-menu-vertical-demo" background-color="#ffffff00"
                        style="border-right: solid 0px;display: flex;justify-content: center;align-items: center;">
                        <el-menu-item index="1">
                            <template #title>
                                <img @click="show = !show" style=" width: 25px;height: 25px;"
                                    src="../../assets/img/icon_1.png" />
                            </template>
                        </el-menu-item>
                    </el-menu>
                </template>
                <el-table :data="filterTableData" border style="width: 100%;" max-height="500" @cell-click="cellClick">
                    <el-table-column align="center" prop="label" label="label">
                        <template #default="scope">
                            <span v-if="scope.row.online_status == '离线'"
                                style="width: 10px;height: 10px;background-color: #909399;border-radius: 50%;float: left;margin-top: 6px;">
                            </span>
                            <div v-else
                                style="width: 10px;height: 10px;background-color: #67c23a;border-radius: 50%;float: left;margin-top: 6px;">
                            </div>
                            {{ scope.row.label }}
                        </template>
                        <template #header>
                            <el-input v-model="search" size="large" suffix-icon="search" placeholder="输入车辆编号" clearable />
                        </template>

                    </el-table-column>
                    <!-- <el-table-column label="" prop="online_status"></el-table-column> -->
                </el-table>
            </el-popover>
        </div>

        <div style="display: flex;height:100%;width: 97%;">
            <el-aside class="aside_box">
                <div class="title_box">
                    <p style="font-size: 20px;color: #fff;float: left; margin-top: -15px;margin-left: 10px;">车辆信息
                    </p>
                </div>
                <div style="display: flex;">
                    <div style="width:60%;height:24vh;margin-top: 10px;">
                        <img :src="carInfo.image" style="width:100%;height:100%;" v-if="carInfo.image" />
                        <img src="../../assets/img/model_1.png" style="width:100%;height:100%;" v-else />
                    </div>
                    <div style="margin-left: 30px;height:250px">
                        <p
                            style="width:288px;font-size:16px;color:#fff;margin-top: 15px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;">
                            所属公司：{{ carInfo.name || "--" }}</P>
                        <p style="font-size:16px;color:#fff;margin-top: 15px;">车辆类型：{{ carInfo.serial_number || "--" }}
                        </P>
                        <p style="font-size:16px;color:#fff;margin-top: 15px;">电池容量：{{
                            carInfo.battery_capacity || "--"
                        }}Kwh
                        </P>
                        <p style="font-size:16px;color:#fff;margin-top: 15px;">电机功率：{{ carInfo.motor_power || "--" }}Kw
                        </P>
                        <p style="font-size:16px;color:#fff;margin-top: 15px;">额定电压：{{ carInfo.rated_voltage || "--" }}V
                        </P>
                        <p style="font-size:16px;color:#fff;margin-top: 15px;">最大速度：{{
                            carInfo.highest_speed || "--"
                        }}Km/h</P>
                        <p style="font-size:16px;color:#fff;margin-top: 15px;">整备质量：{{ carInfo.curb_weight || "--" }}Kg
                        </P>
                    </div>
                </div>

                <div class="car_condition">
                    <div style="height:90%;width:100%;margin-top: 10px;display: flex;flex-direction: column;">
                        <div style="width:100%;height: 10%;margin-right:10px;color:#fff;font-size: 18px;">
                            实时车况
                        </div>
                        <div style="width: 100%;height: 90%;display: flex;justify-content: space-around;">
                            <div class="car_ding">
                                <div class="always">
                                    <div>
                                        {{ decimal(carInfoData?.motor_speed?.data, 1) }}r/min
                                    </div>
                                    <div class="car_data_name">
                                        电机转速
                                    </div>
                                </div>

                                <div class="always">
                                    <div>
                                        {{ decimal(carInfoData?.motor_torque?.data, 1) }} Nm
                                    </div>
                                    <div class="car_data_name">
                                        电机扭矩
                                    </div>
                                </div>
                            </div>
                            <div class="car_ding">
                                <div class="always">
                                    <div>
                                        {{ decimal(carInfoData?.drive_motor_temperature?.data, 1) }} ℃
                                    </div>
                                    <div class="car_data_name">
                                        电机温度
                                    </div>
                                </div>
                                <div class="always">
                                    <div>
                                        {{ decimal(carInfoData?.motor_controller_temperature?.data, 1) }} ℃
                                    </div>
                                    <div class="car_data_name">
                                        控制器温度
                                    </div>
                                </div>
                            </div>
                            <div class="car_ding">
                                <div class="always">
                                    <div>
                                        {{ decimal(carInfoData?.motor_controller_bus_current?.data, 1) }} A
                                    </div>
                                    <div class="car_data_name">
                                        母线电流
                                    </div>
                                </div>
                                <div class="always">
                                    <div>
                                        {{ decimal(carInfoData?.motor_controller_input_voltage?.data, 1) }} V
                                    </div>
                                    <div class="car_data_name">
                                        母线电压
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="dashboard">
                    <div class="ybp_bj">
                        <div style="width: 80%;height: 80%;margin-top: 3%">
                            <div style="width: 40%;height: 100%;float: left;">
                                <div style="width: 100%;height: 100%;-webkit-tap-highlight-color: transparent;user-select: none;"
                                    :id="ybp_left"></div>
                            </div>
                            <div class="ybp_middle">
                                <div style="width:60%;height:35%;margin: 0 auto;">
                                    <img src="../../assets/img/ready.png" style="width:100%;height:80%" alt="">
                                </div>
                                <div style="height: 35%;text-align: center; font-size: 2rem;color: #ffffff;">
                                    {{ car_decimal(carInfoData?.gear?.data_name) }}
                                </div>
                                <div class="ybp_title">
                                    --
                                </div>
                            </div>
                            <div style="width: 40%;height: 100%;float: left;">
                                <div style="width: 100%;height: 100%;-webkit-tap-highlight-color: transparent;user-select: none;"
                                    :id="ybp_rigth"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-aside>
            <el-main class="main_box">
                <div class="main_map">
                    <div style="width: 99.3%; height: 99.5%;" id="container"></div>
                    <div class="video_box">
                        <div class="video_bg" id="id_test_video"></div>
                        <div class="video_bg" id="id_test_video1"></div>
                        <div class="video_bg" id="id_test_video2"></div>
                        <div class="video_bg" id="id_test_video3"></div>
                    </div>
                </div>
                <div class="ganzhi_nox">
                    <div style="width:60%;height:100%; float: left;">
                        <div style="width:100%;height:6%;"></div>
                        <div class="title_bg_dt">
                            故障记录
                        </div>
                        <div class="guzhang">
                            <el-table :data="tableData" element-loading-text="拼命加载中" style="width: 95%;margin: 0 auto;"
                                height="97%" :show-header="false">
                                <el-table-column align="center" label-aligin="center" prop="equipment_name"
                                    min-width="100" />
                                <el-table-column align="center" label-aligin="center" prop="createtime" min-width="150" />
                                <el-table-column align="center" label-aligin="center" prop="fault_level" min-width="80" />
                                <el-table-column align="center" label-aligin="center" prop="fault_details" min-width="250"
                                    show-overflow-tooltip />
                            </el-table>

                        </div>
                    </div>
                    <div style="width:40%;height:100%;float: right;">
                        <div style="width:100%;height:6%;"></div>
                        <div class="title_bg_dt">
                            车辆信息
                        </div>
                        <div style="width: 100%;height: 78%;margin-top: 10px;display: flex;justify-content: space-around;">
                            <div class="main_left">
                                <div class="gzzt_bg">
                                    <p>当 前 电 量</p>
                                    <p style="padding-top: 5px;color: aqua;">
                                        {{ decimal(carInfoData?.electricity?.data, 1) }} %</p>
                                </div>
                                <div class="gzzt_bg">
                                    <p>当 前 电 流</p>
                                    <p style="padding-top: 5px;color: aqua;">
                                        {{ decimal(carInfoData?.current_total_current?.data, 1) }} A
                                    </p>
                                </div>
                                <div class="gzzt_bg">
                                    <p>当 前 电 压</p>
                                    <p style="padding-top: 5px;color: aqua;">
                                        {{ decimal(carInfoData?.current_total_voltage?.data, 1) }} V
                                    </p>
                                </div>
                            </div>
                            <div class="car_tuo">
                                <div class="model_3">
                                    <img :src="carInfo.image" alt style="width: 100%;height: 100%;margin-top: 3%"
                                        v-if="carInfo.image" />
                                    <img src="../../assets/img/model_1.png" alt
                                        style="width: 100%;height: 100%;margin-top: 3%" v-else />
                                </div>
                            </div>
                            <div class="main_right">
                                <div class="gzzt_bg">
                                    <p>车 辆 模 式</p>
                                    <p style="padding-top: 5px;color: aqua;">
                                        {{ car_decimal(carInfoData?.driving_mode?.data_name) }}</p>
                                </div>
                                <div class="gzzt_bg">
                                    <p>急 停 状 态</p>
                                    <p style="padding-top: 5px;color: aqua;">
                                        {{ car_decimal(carInfoData?.stop_state?.data_name) }}
                                    </p>
                                </div>
                                <div class="gzzt_bg">
                                    <p>远 程 状 态</p>
                                    <p style="padding-top: 5px;color: aqua;">--</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-main>
        </div>



    </div>
</template>

<script>
import router from '@/router';
import { nextTick, onBeforeUnmount, onMounted, reactive, ref, toRefs, computed, onUpdated, defineComponent } from 'vue';
import * as echarts from 'echarts';
import CarInfoTypeTwo from './component/CarInfoTypeTwo.vue'
import {
    get_company_car,
    get_car_dynamic_monitoring_car_static_info,
    get_car_dynamic_monitoring_car_video,
    get_car_dynamic_monitoring_car_info,
    get_car_dynamic_monitoring_car_fault_list,
    get_car_dynamic_monitoring_car_gps
} from '../../api/car_monitoring/car_monitoring'
// import { get_info_by_domain } from "../../api/login/login";
let myChart = ""
let myChartTwo = ""
let conMap = ""
let timer = ""
let polyline2 = ""
let player = "1"
let player1 = "1"
let player2 = "1"
let player3 = "1"
let marker = ""
let startIcon = null
export default defineComponent({
    name: "systemDept",
    components: { CarInfoTypeTwo },
    setup() {
        const state = reactive({
            tableData: [],
            carData: [],
            carInfo: {},
            carVideo: {},
            carInfoData: {},
            current_total_current: "",
            current_total_voltage: "",
            count: 0,
            openOne: true,
            imgUrl: "",
        })
        const CarInfoTypeTwoRef = ref()
        const showOpen = ref(true)
        const show = ref(false)
        const search = ref('')
        const ybp_left = ref("ybp_left" + Date.now() + Math.random())
        const ybp_rigth = ref("ybp_rigth" + Date.now() + Math.random())
        //列表过滤搜索

        //获取车辆下拉列表
        const getCar = () => {
            get_company_car().then((res) => {
                state.carData = res.data
            })
        }
        getCar()
        const filterTableData = computed(() =>
            state.carData.filter(
                (data) =>
                    !search.value ||
                    data.value.toLowerCase().includes(search.value.toLowerCase())
            )
        )
        const getLogo = () => {
            let k_host = window.location.host;
            get_info_by_domain(k_host).then((res) => {
                let value = JSON.parse(res.data.data.value)
                state.imgUrl = value.imageUrl
            })
        }
        //  getLogo()
        //获取车辆信息
        const cellClick = (row) => {
            get_car_dynamic_monitoring_car_static_info(row.value).then((res) => {
                state.carInfo = res.data
                state.carVideo = JSON.parse(res.data.videos)
                show.value = false
                state.count++
                getVideo()
                getVideoCar()
            })
            search.value = ""
            // marker = ""
            state.openOne = true
            clearInterval(timer)
            timer = setInterval(() => {
                guiji(row.value)
                getCarInfo(row.value)
                getCarFaultList(row.value)
            }, 2000);
        }
        //故障记录
        const getCarFaultList = (id) => {
            get_car_dynamic_monitoring_car_fault_list(id).then((res) => {
                state.tableData = res.data
            })
        }
        //地图
        const getMap = () => {
            conMap = new AMap.Map("container", {
                mapStyle: "amap://styles/blue",//改变地图样式
                resizeEnable: true, //是否监控地图容器尺寸变化
                zoom: 18, //初始化地图层级
                center: [118.216513, 36.810216], //初始化地图中心点
            })
            startIcon = new AMap.Icon({
                image:
                    "https://qlzxapi.suntaeiv.com/static/images/94fb15c9bff066c05b8be2e7322bb6b.png",
                // 图标所用图片大小
                imageSize: new AMap.Size(30, 40),
            });
        }
        const guiji = (id) => {
            get_car_dynamic_monitoring_car_gps(id).then((res) => {
                // 创建一个 Icon

                if (!marker) {
                    marker = new AMap.Marker({
                        position: [0, 0],
                        icon: startIcon,
                        offset: new AMap.Pixel(-13, -30),
                    });
                    marker.setMap(conMap);
                }
                if (res.data) {
                    let course = res.data.course
                    let gps_type = res.data.gps_type
                    AMap.convertFrom(([res.data.longitude, res.data.latitude]), gps_type, function (status, result) {
                        if (result.info === 'ok') {
                            var resLnglat = result.locations[0];

                            if (state.openOne) {
                                conMap.setZoomAndCenter(19, [resLnglat.lng, resLnglat.lat]); //设置地图中心点
                                state.openOne = false
                            }
                            marker.setAngle(course);
                            marker.setPosition([resLnglat.lng, resLnglat.lat]);

                        }
                    });
                } else {

                    if (state.openOne) {
                        conMap.setZoomAndCenter(19, [0, 0]); //设置地图中心点
                        state.openOne = false
                    }
                    marker.setAngle(0);
                    marker.setPosition([0, 0]);
                    // marker.setPosition([118.216513, 36.810216]);
                }
            })
        }
        //左仪表盘
        const getDashboardLeft = () => {
            const chartDom = document.getElementById(ybp_left.value);
            myChart = echarts.init(chartDom);
            let option;
            option = {
                series: [
                    {
                        type: "gauge",
                        radius: "95%",
                        center: ["50%", "55%"],
                        min: 0,
                        max: 7,
                        splitNumber: 7,
                        progress: {
                            show: true,
                            width: 6,
                        },
                        axisLine: {
                            lineStyle: {
                                width: 8,
                                color: [
                                    [0.7, "#FFFFFF"],
                                    [1, "#fd666d"],
                                ],
                            },
                        },
                        axisTick: {
                            show: false,
                        },
                        splitLine: {
                            length: 3,
                            lineStyle: {
                                width: 1,
                                color: "#999",
                            },
                        },
                        axisLabel: {
                            distance: 5,
                            color: "#999",
                            fontSize: 10,
                        },
                        anchor: {
                            show: true,
                            showAbove: true,
                            size: 10,
                            itemStyle: {
                                borderWidth: 5,
                            },
                        },
                        title: {
                            color: "#fff",
                            fontSize: 10,
                            fontWeight: 800,
                            fontFamily: "Arial",
                            offsetCenter: [0, 20],
                        },
                        detail: {
                            color: "#fff",
                            valueAnimation: true,
                            formatter: function (value) {
                                return value * 1000 + 'r';
                            },
                            fontSize: 15,
                            offsetCenter: [0, "50%"],
                        },
                        data: [
                            {
                                value: 0,
                                name: "1000r/min",
                            },
                        ],
                    },
                ],
            };
            option && myChart.setOption(option);
        }
        //右仪表盘
        const getDashboardRight = () => {
            const chartDomTwo = document.getElementById(ybp_rigth.value);
            myChartTwo = echarts.init(chartDomTwo);
            let optionTwo;
            optionTwo = {
                series: [
                    {
                        type: "gauge",
                        radius: "95%",
                        center: ["50%", "55%"],
                        min: 0,
                        max: 80,
                        splitNumber: 8,//表盘分隔数
                        progress: {
                            show: true,
                            width: 6,
                        },
                        axisLine: {
                            lineStyle: {
                                width: 8,//表盘宽度
                                color: [
                                    [0.7, "#FFFFFF"],
                                    [1, "#fd666d"],
                                ],//表盘颜色
                            },
                        },
                        axisTick: {
                            show: false,
                        },
                        splitLine: {
                            length: 5,
                            lineStyle: {
                                width: 1,
                                color: "#999",
                            },
                        },
                        axisLabel: {
                            distance: 10,
                            color: "#999",
                            fontSize: 10,
                        },
                        anchor: {
                            show: true,//显示指针中心圈
                            showAbove: true,//显示中心点
                            size: 10,//中心点的大小
                            itemStyle: {
                                borderWidth: 5,//指针中心圈的宽度
                            },
                        },
                        //标题MPH
                        title: {
                            color: "#fff",//颜色
                            fontSize: 10,//文字大小
                            fontWeight: 800,//加粗
                            fontFamily: "Arial",//字体
                            offsetCenter: [0, 20],//偏移中心
                        },
                        //内容
                        detail: {
                            color: "#fff",//颜色
                            valueAnimation: true,//是否开启动画
                            formatter: "{value}Km/h",//内容
                            fontSize: 15,//尺寸
                            offsetCenter: [0, "50%"],//偏移中心
                        },
                        data: [
                            {
                                value: 0,
                                name: "MPH",
                            },
                        ],
                    },
                ],
            };
            optionTwo && myChartTwo.setOption(optionTwo);
        }
        //销毁视频
        const getVideo = () => {
            if (player !== "1") {
                player.destroy()
                player = "1"
            }
            if (player1 !== "1") {
                player1.destroy()
                player1 = "1"
            }
            if (player2 !== "1") {
                player2.destroy()
                player2 = "1"
            }
            if (player3 !== "1") {
                player3.destroy()
                player3 = "1"
            }
        }
        //车载视频
        const getVideoCar = () => {
            let video = []
            Object.entries(state.carVideo).map((item) => {
                if (item[0].includes('Pull')) {
                    if (item[1] != "") {
                        video.push(item[1])
                    }
                }
            })
            if (video[0]) {
                nextTick(() => {
                    player = new TcPlayer("id_test_video", {
                        m3u8: video[0],
                        m3u8_cd: video[0],
                        m3u8_hd: video[0],
                        m3u8_sd: video[0],
                        clarityLabel: { od: '蓝光', cd: '超清', hd: '高清', sd: '标清' },
                        //  flv: res.data.camera_video_1, //增加了一个 flv 的播放地址，用于PC平台的播放 请替换成实际可用的播放地址
                        autoplay: true, //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
                        poster: "http://www.test.com/myimage.jpg",
                        controls: "none",
                        volume: "0.5", //初始化音量
                    });
                })
            }
            if (video[1]) {
                nextTick(() => {
                    player1 = new TcPlayer("id_test_video1", {
                        m3u8: video[1],
                        m3u8_cd: video[1],
                        m3u8_hd: video[1],
                        m3u8_sd: video[1],
                        clarityLabel: { od: '蓝光', cd: '超清', hd: '高清', sd: '标清' },
                        //  flv: res.data.camera_video_1, //增加了一个 flv 的播放地址，用于PC平台的播放 请替换成实际可用的播放地址
                        autoplay: true, //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
                        poster: "http://www.test.com/myimage.jpg",
                        controls: "none",
                        volume: "0.5", //初始化音量
                    });
                })
            }
            if (video[2]) {
                nextTick(() => {
                    player2 = new TcPlayer("id_test_video2", {
                        m3u8: video[2],
                        m3u8_cd: video[2],
                        m3u8_hd: video[2],
                        m3u8_sd: video[2],
                        clarityLabel: { d: '蓝光', cd: '超清', hd: '高清', sd: '标清' },
                        //  flv: res.data.camera_video_1, //增加了一个 flv 的播放地址，用于PC平台的播放 请替换成实际可用的播放地址
                        autoplay: true, //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
                        poster: "http://www.test.com/myimage.jpg",
                        controls: "none",
                        volume: "0.5", //初始化音量
                    });
                })
            }
            if (video[3]) {
                nextTick(() => {
                    player3 = new TcPlayer("id_test_video3", {
                        m3u8: video[3],
                        m3u8_cd: video[3],
                        m3u8_hd: video[3],
                        m3u8_sd: video[3],
                        clarityLabel: { od: '蓝光', cd: '超清', hd: '高清', sd: '标清' },
                        //  flv: res.data.camera_video_1, //增加了一个 flv 的播放地址，用于PC平台的播放 请替换成实际可用的播放地址
                        autoplay: true, //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
                        poster: "http://www.test.com/myimage.jpg",
                        controls: "none",
                        volume: "0.5", //初始化音量
                    });
                })
            }
        }
        //车辆信息
        const getCarInfo = (id) => {
            get_car_dynamic_monitoring_car_info(id).then((res) => {
                if (res.data === null) {
                    myChartTwo.setOption({
                        series: [
                            {
                                data: [
                                    {
                                        value: 0,
                                        name: "MPH",
                                    },
                                ],
                            },
                        ],
                    });
                    myChart.setOption({
                        series: [
                            {
                                data: [
                                    {
                                        value: 0,
                                        name: "1000r/min",
                                    },
                                ],
                            },
                        ],
                    });
                } else {
                    state.carInfoData = res.data
                    if (state.carInfoData.online_status !== "0") {
                        state.current_total_current = Number(state.carInfoData?.current_total_current?.data).toFixed(1)
                        state.current_total_voltage = Number(state.carInfoData?.current_total_voltage?.data).toFixed(1)
                    } else {
                        state.current_total_current = 0
                        state.current_total_voltage = 0
                    }
                    myChartTwo.setOption({
                        series: [
                            {
                                data: [
                                    {
                                        value: state.current_total_current,
                                        name: "MPH",
                                    },
                                ],
                            },
                        ],
                    });
                    myChart.setOption({
                        series: [
                            {
                                data: [
                                    {
                                        value: state.current_total_voltage / 1000,
                                        name: "1000r/min",
                                    },
                                ],
                            },
                        ],
                    });
                }
            })
        }

        const openTypeOne = () => {
            showOpen.value = true
            state.tableData = []
            search.value = ""
            show.value = false
            state.carInfo = {}
            nextTick(() => {
                getMap()
                getDashboardLeft()
                getDashboardRight()
            })
        }
        const openTypeTwo = () => {
            showOpen.value = false
            conMap && conMap.destroy();
            show.value = false
            getVideo()
            clearInterval(timer)
            nextTick(() => {
                CarInfoTypeTwoRef.value.openDialog()
            })
        }
        const close = () => {
            router.push({ path: "/home_page" });
            if (document.exitFullScreen) {
                document.exitFullscreen()
            }
            //兼容火狐
            if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen()
            }
            //兼容谷歌等
            if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen()
            }
            //兼容IE
            if (document.msExitFullscreen) {
                document.msExitFullscreen()
            }
        }
        const decimal = (data, value) => {
            if (state.carInfoData.online_status !== "0") {
                if (data) {
                    if (data == 0) {
                        return "--"
                    }
                    else if (data !== "--") {
                        return Number(data).toFixed(value)
                    }
                }
            }
            return "--"
        }
        const car_decimal = (data) => {
            if (state.carInfoData.online_status !== "0") {
                if (data) {
                    return data
                }
            }
            return "--"
        }
        onMounted(() => {
            nextTick(() => {
                getMap()
                getDashboardLeft()
                getDashboardRight()
            })
            if (document.documentElement.RequestFullScreen) {
                document.documentElement.RequestFullScreen();
            }
            //兼容火狐
            if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            }
            //兼容谷歌等可以webkitRequestFullScreen也可以webkitRequestFullscreen
            if (document.documentElement.webkitRequestFullScreen) {
                document.documentElement.webkitRequestFullScreen();
            }
            //兼容IE,只能写msRequestFullscreen
            if (document.documentElement.msRequestFullscreen) {
                document.documentElement.msRequestFullscreen();
            }

        });
        onBeforeUnmount(() => {
            conMap && conMap.destroy();
            marker = null
            getVideo()
            clearInterval(timer)
        })
        return {
            CarInfoTypeTwoRef,
            close,
            // open,
            filterTableData,
            show,
            ybp_left,
            ybp_rigth,
            search,
            cellClick,
            showOpen,
            decimal,
            car_decimal,
            openTypeOne,
            openTypeTwo,
            ...toRefs(state)
        }
    }
})
</script>

<style >
#container {
    width: 100%;
    height: 100%;
}

.amap-logo {
    display: none !important;
    visibility: hidden !important;
}

.amap-copyright {
    display: none !important;
    visibility: hidden !important;
}

.guzhang {
    width: 100%;
    height: 78%;
    margin-top: 10px;
}

.guzhang .el-table {
    color: white;
    background-color: transparent;
}

.guzhang .el-table th,
.guzhang .el-table tr {
    border: 0;
    background-color: transparent;
}

.guzhang .el-table td.el-table__cell {
    border: 0;
}

.guzhang .el-table__inner-wrapper::before {
    background-color: #fff;
    opacity: 0.0;
}

.guzhang .el-table tbody tr {
    pointer-events: none;
}

/* .el-table__body-wrapper::-webkit-scrollbar {
    width: 0;
    height: 0;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0), 0);
    border-radius: 5px;
}

.el-table__body-wrapper::-webkit-scrollbar-track {
    background-color: rgba(255, 255, 255, 0);
} */

.guzhang .el-table__body-wrapper {
    overflow-y: auto;

    &::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 5px;
        /*高宽分别对应横竖滚动条的尺寸*/
        height: 10px;
    }

    &::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 5px;
        background-color: #143ea157;

    }

    &::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: #ededed00;
        border-radius: 10px;
    }
}
</style>
<style scoped>
/* :deep(.amap-layers canvas) {
    height: 690px !important;
} */

.common-layout {
    width: 100%;
    height: 100%;
    display: flex;
    background-image: url("../../assets/img/back.png");
    background-size: 100% 100%;
}

.header_box {
    width: 100%;
    height: 80px;
    background-image: url("../../assets/img/top_title.png");
    background-size: 100% 100%;
}

.top_normal {
    width: 10%;
    height: 55px;
    float: left;
    text-align: center;
    margin-left: 50px;
    margin-top: 25px;
    line-height: 60px;
    background-image: url("../../assets/img/menu_normal.png");
    background-size: 100% 100%;
}

.car_list {
    width: 11%;
    height: 380px;
    float: left;
    background-color: #fff;
    z-index: 100;
    position: absolute;
    left: 250px;
    top: 50px;
}

.suntae {
    width: 56%;
    color: #fff;
    font-size: 36px;
    float: left;
    position: relative;
}

:deep(.el-image) {
    width: 38%;
    position: absolute;
    left: 25%;
}

.out_normal {
    width: 10%;
    height: 55px;
    float: right;
    text-align: center;
    margin-top: 25px;
    line-height: 60px;
    background-image: url("../../assets/img/menu_normal.png");
    background-size: 100% 100%;
}

.aside_box {
    width: 35%;
    margin: 15px;
    /* margin-left: 20px; */
    height: 98%;
    /* background-color: red; */
}

.title_box {
    width: 100%;
    height: 20px;
    margin-top: 15px;
    background-image: url("../../assets/img/title_bg_long.png");
    background-size: 100% 100%;
}

.car_condition {
    width: 100%;
    height: 30%;
    margin-top: 15px;
    float: left;
    border-top: 4px #409eff solid;
    border-bottom: 4px #409eff solid;
    padding-bottom: 10px;
}

.car_ding {
    width: 30%;
    height: 100%;
    float: left;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly
}

.always {
    width: 100%;
    height: 33%;
    color: #fff;
    font-size: 20px;
    text-align: center;
    background-image: url("../../assets/img/car_data.png");
    background-size: cover;
}

.car_data_name {
    font-size: 16px;
    margin-top: 10px;
}

.dashboard {
    width: 100%;
    height: 24vh;
    float: left;
}

.ybp_bj {
    height: 100%;
    width: 100%;
    margin-top: 15px;
    background-image: url("../../assets/img/ybp_box.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
}

.ybp_middle {
    width: 20%;
    height: 90%;
    float: left;
    background-image: url("../../assets/img/ybp_middle.png");
    background-size: 100% 100%;
}

.ybp_title {
    height: 25px;
    width: 60px;
    margin: auto;
    line-height: 25px;
    text-align: center;
    font-size: 1rem;
    color: #ffffff;
    border: inset;
    border-color: #dfdfdf;
}

.main_box {
    width: 65%;
    height: 100%;
}

.main_map {
    width: 100%;
    height: 64%;
    background-image: url("../../assets/img/map_box.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-content: center;
    padding-top: 0.5%;
    position: relative
}

.video_box {
    width: 100%;
    height: 23%;
    position: absolute;
    z-index: 100;
    bottom: 1%;
    display: flex;
    justify-content: space-around;
}

.video_bg {
    width: 24%;
    height: 100%;
    text-align: right;
}

.vcp-player {
    background: url("../../assets/img/car/caidan1.png");
    background-size: 100% 100%;
}

#container {
    width: 100%;
    height: 100%;
}

.ganzhi_nox {
    width: 100%;
    height: 33%;
    margin-top: 10px;
    background-image: url("../../assets/img/ganzhi_box.png");
    background-size: 100% 100%;
}

.title_bg_dt {
    width: 50%;
    height: 15%;
    background-image: url("../../assets/img/title_bg_dt.png");
    background-size: 100% 100%;
    margin: 0 auto;
    text-align: center;
    line-height: 40px;
    color: #FFF;
    font-size: 20px;
}



.main_left {
    width: 25%;
    height: 93%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: rgb(255, 255, 255);
}

.main_right {
    width: 25%;
    height: 90%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: rgb(255, 255, 255);
}

.gzzt_bg {
    width: 100%;
    height: 31%;
    background-image: url("../../assets/img/gzzt_bg.png");
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 14px;
}

.car_tuo {
    width: 45%;
    height: 90%;
    margin-top: 2%;
    background-image: url("../../assets/img/car_tuo.png");
    background-size: 100% 100%;
    position: relative;
}

.model_3 {
    width: 100%;
    height: 65%;
    background-size: 100% 100%;
    position: absolute;
    top: -3%;
}

.close {
    width: 2%;
    height: 3%;
    position: absolute;
    top: 5%;
    left: 96%;
}

::v-deep.el-table::before {
    display: none !important;
}

::v-deep.el-table__body-wrapper::-webkit-scrollbar {
    /*width: 0;宽度为0隐藏*/
    width: 0px !important;

}
</style>